import React, { Component } from 'react';

export default class Footer extends Component {
	render() {
		return (
			<footer>
				<div className="container">
					<div className="row">
						<div className="col-md-4">
							<span className="copyright">Copyright &copy; justsang.com 2025</span>
						</div>
						<div className="col-md-4">
							<ul className="list-inline social-buttons">
								<li>
									<a href="https://www.linkedin.com/in/justin-tsang1/">
										<i className="fa fa-linkedin"></i>
									</a>
								</li>
								<li>
									<a href="https://github.com/tsangjustin/">
										<i className="fa fa-github"></i>
									</a>
								</li>
								<li>
									<a href="https://medium.com/@justin104">
										<i className="fa fa-medium"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx